import { axiosInstance, sendPost } from "src/utils/sendApi"
import { Headers } from "../interface"
import { sendCredsHostnames } from "src/constants"

export const fetchAuditLogListApi = sendPost("v1/data/_audit_log")

export const fetchAuditLogActionsListApi = sendPost("v1/data/_audit_log_actions")

export const fetchAuditLogExportApi = (
  params: any,
  headers: Headers,
  options: any = { responseType: 'blob' }
) => {
  return axiosInstance.post(
    process.env.REACT_APP_API_URL + 'v1/data/_audit_log_export',
    params,
    {
      headers,
      ...(sendCredsHostnames.includes(window.location.hostname) && {
        withCredentials: true,
      }),
      ...options,
    }
  )
}
